/* eslint-disable react/jsx-props-no-spreading */
import { selectIsUserAuthenticated } from 'features/auth/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'

interface IProtectedRouteProps {
  component: React.FC<any> | React.ComponentType<any>
  [key: string]: any
  forAuth?: boolean
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ forAuth = true, component: Component, ...restOfProps }) => {
  const isAuthenticated = useSelector(selectIsUserAuthenticated)

  const tExp = forAuth ? isAuthenticated : !isAuthenticated
  if (isAuthenticated && !forAuth) return <Redirect to="/slots/casino" />
  return (
    <Route {...restOfProps} render={props => (tExp ? <Component {...props} /> : <Redirect to="/slots/casino" />)} />
  )
}

export default ProtectedRoute
